import Link from "next/link";

const normalizeCategoryValue = (value) => String(value || "").trim().toLowerCase();

const CategoryBar = ({ categories = [], activeCategory = "", className = "" }) => {
  const normalizedActive = normalizeCategoryValue(activeCategory);

  return (
    <nav className={`w-full ${className}`}>
      <ul className="flex flex-wrap justify-center gap-3">
        <li key="all">
          <Link
            href="/blog"
            className={`inline-flex px-4 py-2 rounded-full border text-sm font-medium transition-colors ${
              !normalizedActive
                ? "bg-primary text-white border-primary"
                : "bg-white text-gray-700 border-gray-200 hover:border-primary hover:text-primary"
            }`}
          >
            All
          </Link>
        </li>
        {categories.map((category) => {
          const normalizedCategory = normalizeCategoryValue(category?.value);
          if (!normalizedCategory) return null;
          const isActive = normalizedActive === normalizedCategory;

          return (
            <li key={normalizedCategory}>
              <Link
                href={`/blog?category=${encodeURIComponent(normalizedCategory)}`}
                className={`inline-flex px-4 py-2 rounded-full border text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary text-white border-primary"
                    : "bg-white text-gray-700 border-gray-200 hover:border-primary hover:text-primary"
                }`}
              >
                {category?.label || normalizedCategory}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default CategoryBar;
